/*
 * Ventana «Personalizar producto» de Markegifts: ayudas para decidir, sin tocar el cálculo.
 * - Fecha de entrega estimada (boceto en 2 días laborables + 9 laborables desde que se aprueba).
 * - Precio por unidad todo incluido en la barra de abajo y aviso «con N uds te saldría a…» (con quoteAreaCost).
 * - En cada zona: «Más opciones» plegado (repetición, Pantone y observaciones) y el diseño subido encima de la foto
 *   de la zona, para moverlo y cambiarle el tamaño (vista orientativa).
 * - Desglose plegable (abierto de entrada) y presupuesto para descargar en PDF (ventana de impresión).
 */
(() => {
  const modal = document.getElementById('personalizeModal');
  const acordeon = document.getElementById('areasAccordion');
  if (!modal || !acordeon || modal.dataset.ayudas) return;
  modal.dataset.ayudas = '1';

  const $ = (id) => document.getElementById(id);
  const euros = (n) => (typeof formatMoney === 'function' ? formatMoney(n) : `${n.toFixed(2).replace('.', ',')} €`);
  const escapa = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  /* ---------- Entrega estimada ---------- */
  const FESTIVOS = ['2026-12-08', '2026-12-25', '2027-01-01', '2027-01-06', '2027-04-02', '2027-05-01'];
  const ymd = (d) => new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Madrid' }).format(d);
  const laborable = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !FESTIVOS.includes(ymd(d));
  function sumaLaborables(desde, n) {
    const d = new Date(desde);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (laborable(d)) n--;
    }
    return d;
  }
  function pintarEntrega() {
    const hueco = $('mkEntrega');
    if (!hueco) return;
    const llegada = sumaLaborables(new Date(), 2 + 9);
    const parte = (o) => new Intl.DateTimeFormat('es-ES', { timeZone: 'Europe/Madrid', ...o }).format(llegada);
    const fecha = `${parte({ weekday: 'long' })} ${parte({ day: 'numeric' })} de ${parte({ month: 'long' })}`;
    const navidad = ymd(new Date()) < '2026-12-24' && ymd(llegada) > '2026-12-23' ? ' Llegaría después de Navidad.' : '';
    hueco.innerHTML = `<strong>Entrega estimada: hacia el ${fecha}.</strong> Boceto en 24-48 h y unos 9 días laborables desde que lo apruebas.${navidad}`;
    hueco.hidden = false;
  }

  /* ---------- Precio por unidad y «con N uds» ---------- */
  const precioDe = (input) => (typeof precioUnitarioDe === 'function' ? precioUnitarioDe(input) : Number(input.dataset.unitPrice) || 0);
  function seleccion() {
    const lineas = [...document.querySelectorAll('.qty-input')].map((i) => ({ q: parseInt(i.value, 10) || 0, p: precioDe(i) })).filter((l) => l.q > 0);
    const uds = lineas.reduce((s, l) => s + l.q, 0);
    const producto = uds ? lineas.reduce((s, l) => s + l.q * l.p, 0) / uds : 0;
    return { uds, producto };
  }
  // Coste por unidad con n unidades y las zonas marcadas tal como están (misma cuenta que el presupuesto)
  function porUnidadCon(n, productoUnidad) {
    if (typeof quoteAreaCost !== 'function' || typeof areasData === 'undefined') return null;
    let marcaje = 0;
    for (const chk of acordeon.querySelectorAll('.area-checkbox:checked')) {
      const item = chk.closest('.accordion-item');
      const area = areasData[parseInt(chk.dataset.area, 10)];
      const t = area && area.tecnicas[parseInt(item.querySelector('.tecnica-select').value, 10)];
      if (!t) continue;
      const c = quoteAreaCost(
        t,
        item.querySelector('.colores-select').value,
        item.querySelector('.repite-checkbox')?.checked,
        item.querySelector('.ancho-input')?.value,
        item.querySelector('.alto-input')?.value,
        n
      );
      marcaje += c.subTotalArea;
    }
    return productoUnidad + marcaje / n;
  }
  // Precio del producto con n unidades: por tramos donde la tienda lo da (MKTGifts, MKTextil); si no, el de la tabla
  const productoCon = (n, actual) => (typeof window.mkPrecioProducto === 'function' ? window.mkPrecioProducto(n) : actual);
  const minimoUds = () => window.minQty || (typeof window.mkMinimoUds === 'function' ? window.mkMinimoUds() : 0);

  function pintarUnidadYSugerencia() {
    const unidad = $('mkTotalUnidad');
    const aviso = $('mkSugerencia');
    const { uds, producto } = seleccion();
    const udsCuenta = Math.max(uds, uds ? minimoUds() : 0);
    const ahora = uds ? porUnidadCon(udsCuenta, productoCon(udsCuenta, producto)) : null;
    if (unidad) unidad.textContent = ahora ? `${euros(ahora)}/u con ${uds} uds` : '';
    if (!aviso) return;
    aviso.hidden = true;
    if (!ahora || !acordeon.querySelector('.area-checkbox:checked')) return;
    const paso = Math.max(1, window.stepQty || 1);
    for (const base of [25, 50, 100, 250, 500, 1000, 2500, 5000]) {
      const n = Math.ceil(base / paso) * paso;
      if (n <= udsCuenta || n < minimoUds() || n > uds * 5) continue;
      const luego = porUnidadCon(n, productoCon(n, producto));
      const ahorro = 1 - luego / ahora;
      if (ahorro >= 0.1) {
        aviso.innerHTML = `<span class="mk-sugerencia__larga">Con <strong>${n} uds</strong> te saldría a <strong>${euros(luego)}/u</strong>, un ${Math.round(ahorro * 100)} % menos por unidad.</span><span class="mk-sugerencia__corta">Con <strong>${n} uds</strong>: <strong>${euros(luego)}/u</strong> (un ${Math.round(ahorro * 100)} % menos)</span>`;
        aviso.hidden = false;
        return;
      }
    }
  }

  /* ---------- Cada zona: «Más opciones» y vista previa del diseño ---------- */
  const SITIOS = [
    { re: /pecho\s*izq/i, x: 64, y: 30, w: 14 },
    { re: /pecho\s*der/i, x: 36, y: 30, w: 14 },
    { re: /manga\s*izq/i, x: 82, y: 26, w: 10 },
    { re: /manga\s*der/i, x: 18, y: 26, w: 10 },
    { re: /trasera|espalda|detr[aá]s/i, x: 50, y: 36, w: 34 },
    { re: /frontal|delanter|pecho|frente|cara\s*a/i, x: 50, y: 38, w: 34 },
  ];
  const sitioDe = (nombre) => SITIOS.find((s) => s.re.test(nombre || '')) || { x: 50, y: 48, w: 30 };

  function prepararZona(item) {
    if (item.dataset.ayudas) return;
    const cuerpo = item.querySelector('.accordion-body');
    const archivo = item.querySelector('.file-input');
    if (!cuerpo || !archivo) return;
    item.dataset.ayudas = '1';

    const bloqueArchivo = archivo.closest('.mb-3');
    const repite = item.querySelector('.repite-checkbox')?.closest('.form-check');
    const pantone = item.querySelector('.pantone-input')?.closest('.mb-3');
    const notas = item.querySelector('textarea')?.closest('.mb-3');

    // El diseño, justo después de técnica y colores; lo poco habitual, plegado
    const etiqueta = bloqueArchivo.querySelector('.form-label');
    if (etiqueta) etiqueta.innerHTML = 'Tu diseño <span class="mk-suave">(PDF, JPG, PNG, AI, SVG o ZIP)</span><br><span class="mk-suave">Si aún no lo tienes, puedes enviarlo más tarde por email.</span>';
    const mas = document.createElement('details');
    mas.className = 'mk-mas';
    mas.innerHTML = '<summary>Más opciones: repetición de pedido, colores Pantone y observaciones</summary>';
    [repite, pantone, notas].forEach((b) => b && mas.appendChild(b));
    if (pantone && !pantone.querySelector('.mk-suave')) {
      pantone.querySelector('.form-label')?.insertAdjacentHTML('afterend', '<p class="mk-suave mk-pantone-ayuda">Si no los sabes, los sacamos de tu logo.</p>');
    }
    // Donde el cliente escribe el tamaño de su diseño (MKTGifts, MKTextil), que se entienda que es el suyo
    const anchoIn = item.querySelector('.ancho-input');
    if (anchoIn && !anchoIn.readOnly) {
      const etiquetas = [['.ancho-input', 'Ancho de tu diseño'], ['.alto-input', 'Alto de tu diseño']];
      for (const [sel, texto] of etiquetas) {
        const label = item.querySelector(sel)?.closest('.col')?.querySelector('.form-label');
        if (label) label.textContent = `${texto} (${window.marcajeEnCm ? 'cm' : 'mm'}):`;
      }
    }
    const ancla = item.querySelector('.mk-tecnicas-caja') || item.querySelector('.row');
    // Tras las medidas (en Markegifts, tras «¿Cuánto mide tu diseño?»): el archivo va después de decir el tamaño
    const tras = cuerpo.querySelector('.mk-medida') || cuerpo.querySelector('.row:has(.ancho-input)') || ancla;
    tras.after(bloqueArchivo);
    bloqueArchivo.after(mas);

    // Vista previa: el diseño sobre la foto de la zona
    const area = typeof areasData !== 'undefined' ? areasData[parseInt(item.querySelector('.area-checkbox')?.dataset.area, 10)] : null;
    const foto = !area?.imagen ? '' : typeof window.mkImagenZona === 'function' ? window.mkImagenZona(area) : String(area.imagen).replace(/^http:\/\//, 'https://');
    if (!foto) return;
    const previa = document.createElement('div');
    previa.className = 'mk-previa';
    previa.hidden = true;
    previa.innerHTML = `
      <div class="mk-previa__lienzo">
        <img class="mk-previa__zona" src="${escapa(foto)}" alt="">
        <div class="mk-previa__logo" tabindex="0" aria-label="Tu diseño: arrástralo para colocarlo">
          <img alt="">
          <span class="mk-previa__tirador" aria-hidden="true"></span>
        </div>
      </div>
      <p class="mk-previa__nota">Vista orientativa. Arrastra tu diseño y usa la esquina para cambiar el tamaño: nuestro equipo te prepara el boceto real.</p>`;
    bloqueArchivo.appendChild(previa);
    const lienzo = previa.querySelector('.mk-previa__lienzo');
    const caja = previa.querySelector('.mk-previa__logo');
    const sitio = sitioDe(area.nombre_area);
    const colocar = (x, y, w) => {
      caja.style.left = `${x}%`;
      caja.style.top = `${y}%`;
      caja.style.width = `${w}%`;
    };

    archivo.addEventListener('change', () => {
      const f = archivo.files && archivo.files[0];
      if (!f || !/^image\/(png|jpe?g|svg\+xml|webp|gif)$/i.test(f.type)) {
        previa.hidden = true;
        return;
      }
      const img = caja.querySelector('img');
      if (img.dataset.url) URL.revokeObjectURL(img.dataset.url);
      img.dataset.url = URL.createObjectURL(f);
      img.src = img.dataset.url;
      caja.classList.toggle('mk-previa__logo--multiplica', !/svg|png/i.test(f.type));
      colocar(sitio.x, sitio.y, sitio.w);
      previa.hidden = false;
    });

    // Arrastrar y cambiar el tamaño (en % del lienzo, para que no dependa del ancho de la pantalla)
    let gesto = null;
    caja.addEventListener('pointerdown', (e) => {
      const r = lienzo.getBoundingClientRect();
      gesto = {
        tipo: e.target.classList.contains('mk-previa__tirador') ? 'tamano' : 'mover',
        x: e.clientX,
        y: e.clientY,
        left: parseFloat(caja.style.left),
        top: parseFloat(caja.style.top),
        width: parseFloat(caja.style.width),
        r,
      };
      try {
        caja.setPointerCapture(e.pointerId);
      } catch (error) {}
      e.preventDefault();
    });
    caja.addEventListener('pointermove', (e) => {
      if (!gesto) return;
      const dx = ((e.clientX - gesto.x) / gesto.r.width) * 100;
      const dy = ((e.clientY - gesto.y) / gesto.r.height) * 100;
      if (gesto.tipo === 'mover') colocar(Math.min(100, Math.max(0, gesto.left + dx)), Math.min(100, Math.max(0, gesto.top + dy)), gesto.width);
      else colocar(gesto.left, gesto.top, Math.min(90, Math.max(5, gesto.width + dx * 2)));
    });
    const soltar = () => (gesto = null);
    caja.addEventListener('pointerup', soltar);
    caja.addEventListener('pointercancel', soltar);
    // Con el teclado: flechas para mover, + y − para el tamaño
    caja.addEventListener('keydown', (e) => {
      const l = parseFloat(caja.style.left);
      const t = parseFloat(caja.style.top);
      const w = parseFloat(caja.style.width);
      const pasos = { ArrowLeft: [-2, 0, 0], ArrowRight: [2, 0, 0], ArrowUp: [0, -2, 0], ArrowDown: [0, 2, 0], '+': [0, 0, 2], '-': [0, 0, -2] };
      const p = pasos[e.key];
      if (!p) return;
      e.preventDefault();
      colocar(l + p[0], t + p[1], Math.min(90, Math.max(5, w + p[2])));
    });
  }

  /* ---------- Presupuesto en PDF ---------- */
  function descargar() {
    const ventana = window.open('', '_blank');
    if (!ventana) return;
    const producto = document.querySelector('#personalizeModal .mk-subtitulo')?.textContent.trim() || '';
    const filas = [...document.querySelectorAll('#breakdownProductRows .variant-breakdown-row')]
      .map((f) => `<tr>${[...f.children].map((c, k) => `<td${k ? ' class="n"' : ''}>${escapa(c.textContent.trim())}</td>`).join('')}</tr>`)
      .join('');
    const extras = [...document.querySelectorAll('#extrasTable tr')]
      .map((f) => `<tr>${[...f.children].map((c, k) => `<td${k ? ' class="n"' : ''}>${escapa(c.firstElementChild?.textContent.trim() || c.textContent.trim())}</td>`).join('')}</tr>`)
      .join('');
    const hoy = new Intl.DateTimeFormat('es-ES', { timeZone: 'Europe/Madrid', day: 'numeric', month: 'long', year: 'numeric' }).format(new Date());
    const entrega = $('mkEntrega')?.textContent || '';
    // El logo de la cabecera de la tienda, con su dirección completa (la ventana nueva no tiene la de la página)
    const logoImg = document.querySelector('.header__logo-image:not(.header__logo-image--transparent)');
    const logo = logoImg ? new URL(logoImg.currentSrc || logoImg.src, window.location.href).href : '';
    ventana.document.write(`<!doctype html><html lang="es"><head><meta charset="utf-8"><title>Presupuesto MarkeGifts - ${escapa(producto)}</title>
      <style>body{font:14px/1.5 Arial,Helvetica,sans-serif;color:#1a1a1a;margin:32px}h1{font-size:22px;margin:0}h2{font-size:15px;margin:22px 0 6px}
      table{width:100%;border-collapse:collapse}td,th{padding:6px 8px;border-bottom:1px solid #e5e7eb;text-align:left}.n{text-align:right}
      .cab{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:3px solid #e63151;padding-bottom:14px}
      .cab img{display:block;max-height:56px;max-width:220px;margin-bottom:8px}.tienda{font-size:12px;color:#6b7280}
      .total{margin-top:18px;font-size:18px;text-align:right}.total strong{color:#e63151;font-size:22px}.pie{margin-top:28px;font-size:12px;color:#6b7280}</style></head><body>
      <div class="cab"><div>${logo ? `<img src="${escapa(logo)}" alt="MarkeGifts">` : '<strong>MarkeGifts</strong>'}<div class="tienda">markegifts.com · Tel. 910 054 124 (L-V, 9:00 a 15:00)</div></div>
      <div style="text-align:right"><h1>Presupuesto</h1><div>${escapa(producto)}</div><div class="tienda">${escapa(hoy)}</div></div></div>
      <h2>Productos</h2><table><tr><th>Producto</th><th class="n">Uds</th><th class="n">€/u</th><th class="n">Subtotal</th></tr>${filas}</table>
      <h2>Personalización</h2><table><tr><th>Zona y técnica</th><th class="n">Uds</th><th class="n">€/u</th><th class="n">Subtotal</th></tr>${extras}</table>
      <p class="total">Total: <strong>${escapa($('grandTotal')?.textContent || '')}</strong><br>${escapa($('mkTotalUnidad')?.textContent || '')}</p>
      <p>${escapa(entrega)}</p>
      <p class="pie">Presupuesto orientativo generado en markegifts.com. El precio final se confirma al hacer el pedido. ${escapa(window.location.href.split('?')[0])}</p>
      <script>window.onload = () => { window.print(); };<\/script></body></html>`);
    ventana.document.close();
  }

  /* ---------- Enganches ---------- */
  modal.addEventListener('show.bs.modal', pintarEntrega);
  $('mkDescargar')?.addEventListener('click', descargar);
  new MutationObserver(() => acordeon.querySelectorAll('.accordion-item').forEach(prepararZona)).observe(acordeon, { childList: true });
  const total = $('grandTotal');
  if (total) new MutationObserver(pintarUnidadYSugerencia).observe(total, { childList: true, characterData: true, subtree: true });
  acordeon.addEventListener('change', () => setTimeout(pintarUnidadYSugerencia, 0));
})();
